import { render, staticRenderFns } from "./EscalationTemplate.vue?vue&type=template&id=20411a84&scoped=true&"
import script from "./EscalationTemplate.vue?vue&type=script&lang=js&"
export * from "./EscalationTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20411a84",
  null
  
)

export default component.exports